module.exports = __webpack_public_path__ + "img/DSC_9881.dd7e4af6.jpeg";